import { useState } from 'react';
import { useAuth } from '@/contexts/auth-context';
import type { SearchFormValues } from '../schema';
import { toast } from '@/hooks/use-toast';

export const useSoChiTietCongNoExport = (queryParams?: SearchFormValues | null) => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    if (!entity?.slug) {
      toast({
        description: 'Không tìm thấy thông tin đơn vị.',
        variant: 'default'
      });
      return;
    }

    if (!queryParams) {
      toast({
        description: 'Vui lòng thực hiện tìm kiếm trước khi kết xuất.',
        variant: 'default'
      });
      return;
    }

    setIsExporting(true);
    try {
      const { exportSoChiTietCongNoTheoKhachHangFromApi } = await import('../utils/excel-export');
      await exportSoChiTietCongNoTheoKhachHangFromApi({
        entitySlug: entity.slug,
        queryParams
      });
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug && queryParams),
    isExporting
  };
};
